"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fetchZaps_1 = __importDefault(require("./fetchZaps"));
function useZaps(accountId) {
    const [zaps, setZaps] = react_1.useState({});
    const [isLoading, setIsLoading] = react_1.useState(false);
    react_1.useEffect(() => {
        const fetch = () => __awaiter(this, void 0, void 0, function* () {
            setIsLoading(true);
            const newZaps = yield fetchZaps_1.default(accountId);
            setZaps(newZaps);
            setIsLoading(false);
        });
        fetch();
    }, [accountId]);
    return { zaps, isLoading };
}
exports.default = useZaps;
